import { useState } from "react";
import { useLocation } from "react-router-dom";

const pageTitles: Record<string, string> = {
  "/": "系统总览",
  "/profile": "档案管理系统",
  "/profile/resident": "居民用户档案",
  "/profile/commercial": "工商业用户档案",
  "/meter": "实时抄表系统",
  "/meter/realtime": "实时监控",
  "/meter/history": "历史记录",
  "/sales": "在线售气系统",
  "/sales/purchase": "购气操作",
  "/sales/records": "售气记录",
  "/price": "气价管理系统",
  "/price/ladder": "阶梯气价",
  "/price/history": "价格历史",
  "/report": "报表与分析系统",
  "/report/daily": "日报表",
  "/report/monthly": "月报表",
  "/report/ai": "AI定制报告",
  "/payment": "支付与充值",
  "/settings": "系统设置",
};

export default function TopBar() {
  const location = useLocation();
  const [showNotifications, setShowNotifications] = useState(false);

  const title = pageTitles[location.pathname] || "AI智慧燃气营收管理系统";

  const notifications = [
    { id: 1, type: "danger", text: "老北京涮肉馆 压力异常报警", time: "5分钟前" },
    { id: 2, type: "warning", text: "李秀梅 账户余额不足预警", time: "12分钟前" },
    { id: 3, type: "info", text: "张建国 设备校验即将到期", time: "1小时前" },
    { id: 4, type: "info", text: "系统完成今日数据同步", time: "2小时前" },
  ];

  return (
    <header className="h-14 bg-white border-b border-gray-100 flex items-center justify-between px-6 flex-shrink-0">
      <div className="flex items-center gap-3">
        <h2 className="text-gray-800 font-semibold text-base">{title}</h2>
        <div className="flex items-center gap-1.5 text-xs text-gray-400">
          <div className="w-1.5 h-1.5 rounded-full bg-green-400"></div>
          <span>系统运行正常</span>
        </div>
      </div>

      <div className="flex items-center gap-4">
        {/* Date */}
        <div className="text-xs text-gray-400 hidden md:block">
          2026年04月10日 星期五
        </div>

        {/* Search */}
        <div className="relative hidden md:block">
          <div className="w-5 h-5 flex items-center justify-center absolute left-2.5 top-1/2 -translate-y-1/2">
            <i className="ri-search-line text-gray-400 text-sm"></i>
          </div>
          <input
            type="text"
            placeholder="搜索用户、设备..."
            className="pl-8 pr-3 py-1.5 text-xs bg-gray-50 border border-gray-200 rounded-lg w-48 focus:outline-none focus:border-[#E8531A]/50 focus:bg-white transition-colors"
          />
        </div>

        {/* Notifications */}
        <div className="relative">
          <button
            onClick={() => setShowNotifications(!showNotifications)}
            className="relative w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
          >
            <i className="ri-notification-3-line text-gray-500 text-base"></i>
            <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
          </button>

          {showNotifications && (
            <div className="absolute right-0 top-10 w-80 bg-white rounded-xl shadow-lg border border-gray-100 z-50">
              <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
                <span className="text-sm font-semibold text-gray-800">系统通知</span>
                <span className="text-xs text-[#E8531A] cursor-pointer">全部已读</span>
              </div>
              <div className="py-1">
                {notifications.map(n => (
                  <div key={n.id} className="px-4 py-3 hover:bg-gray-50 cursor-pointer flex items-start gap-3">
                    <div className={`w-2 h-2 rounded-full mt-1.5 flex-shrink-0 ${
                      n.type === "danger" ? "bg-red-500" :
                      n.type === "warning" ? "bg-amber-500" : "bg-blue-400"
                    }`}></div>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs text-gray-700">{n.text}</p>
                      <p className="text-xs text-gray-400 mt-0.5">{n.time}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="px-4 py-2 border-t border-gray-100 text-center">
                <span className="text-xs text-gray-400 cursor-pointer hover:text-gray-600">查看全部通知</span>
              </div>
            </div>
          )}
        </div>

        {/* User avatar */}
        <div className="flex items-center gap-2 cursor-pointer">
          <div className="w-7 h-7 rounded-full bg-[#E8531A] flex items-center justify-center">
            <span className="text-white text-xs font-bold">管</span>
          </div>
        </div>
      </div>
    </header>
  );
}
